import { ecsClient, getGlobalSessionId } from ".";

export interface PaymentMethod {
  pk: string;
  sk: string;
  provider: string;
  email?: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  deletedAt?: string;
}

const PaymentMethodServices = {
  getPaymentMethods: async (): Promise<PaymentMethod[]> => {
    try {
      const sessionId = getGlobalSessionId();
      const response = await ecsClient.get<PaymentMethod[]>(
        "/payment-methods",
        {
          params: { sessionId },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Get payment methods error:", error);
      throw error;
    }
  },

  registerPaymentMethod: async (data: {
    email: string;
    provider: string;
  }): Promise<PaymentMethod> => {
    try {
      const sessionId = getGlobalSessionId();
      const response = await ecsClient.post<PaymentMethod>(
        "/payment-methods/register",
        {
          sessionId,
          provider: data.provider,
          email: data.email,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Register payment method error:", error);
      throw error;
    }
  },
};

export default PaymentMethodServices;
